var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.551 1.127a1.256 1.256 0 0 0-1.102 0L.456 5.89c-.608.309-.608.913 0 1.222l8.993 4.762c.334.17.767.17 1.102 0l8.992-4.762c.61-.309.61-.913 0-1.222l-8.992-4.762Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 6.5.016 4.514c.002.548.447.99.994.99a.99.99 0 0 0 .99-.99V6.5h-2ZM3.366 10.033l6.401 3.358a.5.5 0 0 0 .465 0l6.406-3.358a.25.25 0 0 1 .366.221v5.109a.25.25 0 0 1-.139.224l-6.64 3.302a.5.5 0 0 1-.446 0l-6.64-3.302A.25.25 0 0 1 3 15.363v-5.108a.25.25 0 0 1 .366-.222Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.941b76c2ebb35c1e94c304e2d823e45c.svg";
export { ForwardRef as ReactComponent };